module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/store_images/2_04995cad8e029cfc9136f9fe4427d2f1.png";